import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as message from '../message'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: message.RESOURCE.payload.dimension.partialId,
      partialId: message.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The status of the message processing, tracking agent message states',
    isOptional: false,
    name: 'Status',
    partialId: PartialId.Standard.create('status'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.messageStatus.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
